<div #dayList class="wrap">
  <div
    #dayElem
    *ngFor="let item of model.items"
    class="item border-sm"
    [class.border-today]="item.isToday && selectedDay !== item.dayName"
    [class.item-unavailable]="item.disabled && selectedDay !== item.dayName"
    [class.item-unavailable-selected]="item.disabled && selectedDay === item.dayName"
    [class.item-selected]="selectedDay === item.dayName"
    (click)="onDayClick(item, dayElem)"
    [appHidden]="!displayedDays.includes(item.dayName)"
  >
    <div class="month">{{ item.monthNameI18n | translate }}</div>
    <div class="day-num">{{ item.dayCalendarNumber }}</div>
    <div class="day-name">
      {{
        item.isToday
          ? ("@common.today" | translate | titlecase)
          : (item.dayNameI18n | translate)
      }}
    </div>
  </div>
</div>
